export const VisaRequestsStatusesEnum = {
  Approved: {
    key: 'approved',
    value: 'approved',
  },
  Declined: {
    key: 'declined',
    value: 'declined',
  },
  Pending: {
    key: 'pending',
    value: 'pending',
  },
  RequestInfo: {
    key: 'request_info',
    value: 'request-more-information',
  },
  Expired: {
    key: 'expired',
    value: 'expired',
  },
};
